import { useSelector } from 'react-redux';
import { RootState } from '../../models/_root-state.model';

export const usePlansAvailable = (): Record<string, any> => useSelector((state: RootState) => state.plansAvailable);
